import React from 'react';
import { Modal, Button, Typography, Spin } from 'antd';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from 'recharts';

const TradeTimelineModal = ({
  open,
  onClose,
  loading,
  data,
  event,
  onCopyJson,
  onCreateTicket
}) => {
  return (
    <Modal
      title="Trade Clause Timeline"
      open={open}
      onCancel={onClose}
      width={900}
      footer={[
        <Button key="copy" onClick={onCopyJson} disabled={!data}>
          Copy JSON
        </Button>,
        <Button key="jira" onClick={onCreateTicket} disabled={!data}>
          Create Jira Ticket
        </Button>,
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      {loading ? (
        <Spin tip="Loading timeline data..." />
      ) : data?.error ? (
        <div style={{ color: 'red' }}>
          <Typography.Text strong>Error loading timeline:</Typography.Text>
          <br />
          {data.error}
        </div>
      ) : data?.dates ? (
        <div>
          <div style={{ marginBottom: 16 }}>
            <Typography.Text strong>
              {event?.ticker} — {data.field_name} vs {data.threshold_name}
            </Typography.Text>
            <br />
            <Typography.Text type="secondary">
              Sector: {data.sector || 'N/A'} | 
              Trade Date: {data.trade_date} | 
              Type: {event?.event_type} | 
              Qty: {event?.qty} | 
              Price: €{event?.price}
            </Typography.Text>
          </div>
          <ResponsiveContainer width="100%" height={400}>
            <LineChart
              data={(data?.dates || []).map((date, idx) => ({
                date,
                field_value: data.field_values[idx],
                threshold_value: data.threshold_values[idx],
              }))}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="date"
                angle={-45}
                textAnchor="end"
                height={80}
                tick={{ fontSize: 11 }}
              />
              <YAxis />
              <Tooltip
                formatter={(value) => (value != null ? value.toFixed(2) : 'N/A')}
                labelStyle={{ fontWeight: 'bold' }}
              />
              <Legend />
              <ReferenceLine
                x={data.trade_date}
                stroke="red"
                strokeDasharray="3 3"
                label={{ value: 'Trade', position: 'top', fill: 'red' }}
              />
              <Line
                type="monotone"
                dataKey="field_value"
                stroke="#1677ff"
                strokeWidth={2}
                name={data.field_name}
                connectNulls
                dot={{ r: 3 }}
              />
              <Line
                type="monotone"
                dataKey="threshold_value"
                stroke="#ff4d4f"
                strokeWidth={2}
                name={data.threshold_name}
                connectNulls
                dot={{ r: 3 }}
                strokeDasharray="5 5"
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div>No data available</div>
      )}
    </Modal>
  );
};

export default TradeTimelineModal;




